import _slicedToArray from "/Users/itsasbreuk/Documents/itsawallet/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { useEffect, useRef, useReducer } from 'react';
import getStateObject from './get-stateobject';

var useQueue = function useQueue() {
  var initialValue = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var queueArray = useRef(initialValue);
  var id = useRef(0);

  var _useReducer = useReducer(function (x) {
    return x + 1;
  }, 0),
      _useReducer2 = _slicedToArray(_useReducer, 2),
      _ = _useReducer2[0],
      forceUpdate = _useReducer2[1]; // const queue = getStateObject(id, queueArray);


  var queue = useRef(getStateObject(id, queueArray, forceUpdate));
  useEffect(function () {
    return function () {
      queue.empty();
    };
  }, []);
  return queue.current;
};

export default useQueue;